<div *ngIf="personalHierarchy$ | async as personalHierarchy">
    <adapt-display-navigation-node class="heading-node"
                                   [node]="personalHierarchy"></adapt-display-navigation-node>
    <ul>
        <li *ngFor="let childNode of personalHierarchy?.children || []">
            <adapt-display-link-hierarchy [hierarchy]="childNode"></adapt-display-link-hierarchy>
        </li>
    </ul>
</div>
